import { render, staticRenderFns } from "./Coming.vue?vue&type=template&id=2ec951b8"
import script from "./Coming.vue?vue&type=script&lang=js"
export * from "./Coming.vue?vue&type=script&lang=js"
import style0 from "./Coming.vue?vue&type=style&index=0&id=2ec951b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports